import type { RouteObject } from 'react-router-dom';
import App from '../App';
import AuthScreen from '../screens/AuthScreen';
import CartScreen from '../screens/CartScreen';
import CatalogScreen from '../screens/CatalogScreen';
import CategoryScreen from '../screens/CategoryScreen';
import ManufacturerScreen from '../screens/ManufacturerScreen';
import NotFoundScreen from '../screens/NotFoundScreen';
import OrderSuccessScreen from '../screens/OrderSuccess';
import OrdersScreen from '../screens/OrdersScreen';
import ProfileScreen from '../screens/ProfileScreen';
import ProductScreen from '../screens/ProductScreen';

// Route objects are framework-agnostic and can be reused by browser or server routers.
export const websiteRoutes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <CatalogScreen /> },
      { path: 'category/:categoryId', element: <CategoryScreen /> },
      { path: 'manufacturer/:manufacturerId', element: <ManufacturerScreen /> },
      { path: 'product/:productId', element: <ProductScreen /> },
      { path: 'cart', element: <CartScreen /> },
      { path: 'order-success', element: <OrderSuccessScreen /> },
      { path: 'orders', element: <OrdersScreen /> },
      { path: 'login', element: <AuthScreen /> },
      { path: 'profile', element: <ProfileScreen /> },
      { path: '*', element: <NotFoundScreen /> },
    ],
  },
];
